// Vendor imports
const classNames = require('classnames')
const React = require('react')
const qs = require('qs')
// Shared imports
const BemEntity = require('shared/bem')
const { urlWithoutProtocol } = require('shared/utils')
// Client V2 common imports
const { CapsuleButton } = require('client-v2/common/components/buttons')
const LazyImage = require('client-v2/common/components/lazy-image')
const UserAvatar = require('client-v2/common/components/user-avatar')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('IntoLandingCuratedUser')

/**
 * This is a constant so that it does not change between renders
 * @type {[]}
 * @readonly
 */

function IntoLandingCuratedUser(props) {
  const { isAndroid, isIos, isDesktop, iosDeeplinkHref, onFollowClick, user } = props

  const handleFollowClick = React.useCallback(
    event => {
      if (isAndroid) {
        return
      }
      event.preventDefault()
      if (isIos) {
        const userProfile = location.href + `/${user.username}`
        const queryString = qs.stringify({
          // Delivered as query parameter when handling the universal links.
          'deeplink_url': userProfile,
          // Fallbacks to mix://$deeplink_path when universal links do not work.
          // Docs: https://docs.branch.io/pages/links/integrate/#deep-linking
          '$deeplink_path': urlWithoutProtocol(userProfile)
        })
        location.assign(`${iosDeeplinkHref}?${queryString}`)
        return
      }
      if (isDesktop){
        onFollowClick({ isDownloadPromptVisible: true })
      }
    },
    [ iosDeeplinkHref, isAndroid, isDesktop, isIos, onFollowClick, user ]
  )

  // Render
  if (!user) {
    return null
  }
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag('div', {
        className: bem.element('user')
      },
        tag('div', {
          className: bem.element('user-info')
        },
          tag(UserAvatar, {
            className: bem.element('user-avatar'),
            badge: false,
            href: true,
            user
          }),
          tag('a', {
            className: bem.element('user-link'),
            href: `/${user.username}`
          },
            tag('span', {
              className: bem.element('display-name')
            },
              user['display_name']
            ),
            tag('span', {
              className: bem.element('username')
            },
              '@' + user.username
            )
          )
        ),
        tag(CapsuleButton, {
          className: bem.element('follow'),
          href: `/${user.username}`,
          onClick: handleFollowClick
        },
          'Follow'
        )
      ),
      tag('div', {
        className: bem.element('feed')
      },
        user.feed.slice(0, 3).map(item => (
          tag(LazyImage, {
            key: item['url_hash'],
            className: bem.element('image'),
            sources: [item.thumbnail],
            href: `!${item['url_hash']}`,
            target: '_blank'
          })
        ))
      )
    )
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  const ArticleModelRecord = require('client-v2/common/models/article/record')

  IntoLandingCuratedUser.propTypes = {
    // Values
    className: PropTypes.string,
    item: PropTypes.shape(ArticleModelRecord.propTypes),
    // Callbacks
    onFollowClick: PropTypes.func
  }
}

module.exports = IntoLandingCuratedUser
